import { render, staticRenderFns } from "./Wastes.vue?vue&type=template&id=15d3dfd4&"
import script from "./Wastes.vue?vue&type=script&lang=js&"
export * from "./Wastes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports